import { render, staticRenderFns } from "./listaestudiantes.vue?vue&type=template&id=1aa575ac"
import script from "./listaestudiantes.vue?vue&type=script&lang=js"
export * from "./listaestudiantes.vue?vue&type=script&lang=js"
import style0 from "./listaestudiantes.vue?vue&type=style&index=0&id=1aa575ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports